<template>
  <p class="before-unlock-caution">自転車側で「開始」ボタンを押した直後に<br>アプリ側で「鍵を開ける」ボタンを押して下さい</p>
</template>

<script>
export default {
  name: "DbsBeforeUnlockCaution",
};
</script>
<style scoped>
.before-unlock-caution {
  margin-top: 40px;
  text-align: center;
  font-weight: bold;
  font-size: 3.8vw;
  line-height: 25px;
  width: 95%;
  padding-bottom: 20px;
  color: #ff0000;
}
</style>